/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2948cd55f3b3fa5b570671c31cf8b90>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconNew = _interopRequireDefault(require("@atlaskit/icon/components/icon-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "MergeSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/merge-success
 * Usage guidance:
 * Single purpose - Reserved for branches in Bitbucket and Jira that have successfully merged.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const MergeSuccessIcon = props => /*#__PURE__*/_react.default.createElement(_iconNew.default, Object.assign({
  name: "MergeSuccessIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m6.174.77 1.152.96-3.333 4a.75.75 0 0 1-1.152 0l-1.667-2 1.152-.96 1.09 1.308zM8.5 2.5h1.25a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8.5zm-5 8.128V7.5H5v3.128a2.251 2.251 0 1 1-1.5 0M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
MergeSuccessIcon.displayName = 'MergeSuccessIcon';
var _default = exports.default = MergeSuccessIcon;